import React from 'react';
import Layout from '@rocketseat/gatsby-theme-docs/src/components/Layout';
import SEO from '@rocketseat/gatsby-theme-docs/src/components/SEO';
import Landing from './Landing';

export default function Home() {
  return (
    <Layout homepage>
      <SEO />
      <Landing />
    </Layout>
  );
}